"use strict";

import "./ShareDialog.css";
import React from "react";
import ReactDom from "react-dom";
import lang from "vwa/lang";
import Form from "vwa/components/Form";
import Dialog from "vwa/components/Dialog";
import Button from "vwa/components/Button";
import Select from "vwa/components/Select";

export default class ShareDialog extends React.Component {
	
	getCollaboration() {
		return {
			collaborator:	ReactDom.findDOMNode(this.refs.collaborator).value,
			privilege:		parseInt(ReactDom.findDOMNode(this.refs.privilege).value)
		};
	}
	
	renderUserOption(possibleCollaborator) {
		return (
			<option
				key={possibleCollaborator.id}
				value={possibleCollaborator.id}
			>
				{`${possibleCollaborator.name}${possibleCollaborator.isGroup?" (group)":""}`}
			</option>
		);
	}
	
	renderUserOptions() {
		if (!this.props.possibleCollaborators)
			return;
		
		return this.props.possibleCollaborators.map(this.renderUserOption.bind(this));
	}
	
	renderPrivilegeOptions() {
		const privileges = [
			{value: 1, text: lang.CAN_VIEW},
			{value: 2, text: lang.CAN_EDIT},
			{value: 3, text: lang.CAN_SHARE},
			{value: 4, text: lang.CAN_DELETE}
		];
		
		return privileges.map(privilege => (
			<option
				key={privilege.value}
				value={privilege.value}
				disabled={privilege.value > this.props.maxPrivilege}
			>
				{privilege.text}
			</option>
		));
	}
	
	render() {
		return (
			<Dialog shown={this.props.shown} className="ShareDialog">
				<header>
					<h1>{lang.SHARE_POI}</h1>
				</header>
				<Form>
					<label>{lang.COLLABORATOR}</label>
					<Select ref="collaborator">
						{this.renderUserOptions()}
					</Select>
					
					<label>{lang.PRIVILEGE}</label>
					<Select ref="privilege">
						{this.renderPrivilegeOptions()}
					</Select>
				</Form>
				<footer>
					<Button onClick={() => this.props.onCancel()}>{lang.CANCEL}</Button>
					<Button onClick={() => this.props.onShare(this.getCollaboration())} className="Red">{lang.SHARE}</Button>
				</footer>
			</Dialog>
		);
	}
	
}

ShareDialog.propTypes = {
	shown:					React.PropTypes.bool,
	maxPrivilege:			React.PropTypes.number,
	onCancel:				React.PropTypes.func,
	onShare:				React.PropTypes.func,
	possibleCollaborators:	React.PropTypes.arrayOf(
								React.PropTypes.shape({
									id:			React.PropTypes.string,
									name:		React.PropTypes.string,
									isGroup:	React.PropTypes.bool
								})
							)
};

ShareDialog.defaultProps = {
	shown:			false,
	maxPrivilege:	4,
	onCancel:		() => {},
	onShare:		collaboration => {}
};


// WEBPACK FOOTER //
// ./src/view/POICollaborators/ShareDialog/ShareDialog.jsx